/* eslint-disable react/prop-types */
import styled from '@emotion/styled';

import Picture from './oc-picture';
import Text from './oc-text';
// eslint-disable-next-line camelcase
import placeholder_url from '../../placeholder';

const defaults = {
  heroDesktop: placeholder_url(2680, 1090),
};

const HeroContainer = styled.div`
  padding-top: 20%;
  padding-bottom: 15%;
  align-items: flex-start;
  background-position: center;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  background-image: url(${props => (props.mediaType === 'image' ? props.imgDesktop : 'none')});
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 1199px) {
    background-image: url(${props => (props.mediaType === 'image' ? props.imgTablet : 'none')});
    padding: 25% 0 20% 0;
  }

  @media (max-width: 767px) {
    background-image: url(${props => (props.mediaType === 'image' ? props.imgMobile : 'none')});
    padding: 18% 0 12% 0;
  }
`;

const HeroVideo = styled.video`
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
`;

const MainContent = styled.div`
  color: #ffffff;
  font-size: 30px;
  text-align: center;
  width: 100%;
  position: relative;
`;

const HeroTitle = styled.h1`
  color: #FFFFFF;
  font-family: 'Oswald Regular', sans-serif;
  font-size: 80px;
  font-style: normal;
  font-weight: 400;
  line-height: 85px;
  margin-bottom: 16px;
  text-shadow: 0 -1px 10px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-size: 54px;
    line-height: 58px;
  }

  @media (max-width: 767px) {
    font-size: 36px;
    line-height: 38px;
  }
`;

const HeroPosthead = styled.div`
  color: #ffffff;
  text-align: center;
  text-shadow: 0 -1px 10px rgba(0, 0, 0, 0.4);
  font-family: 'OC Roboto', sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 64px;

  @media (max-width: 1199px) {
    font-size: 20px;
    line-height: 18px;
    margin-bottom: 48px;
  }

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 12px;
    margin-bottom: 24px;
  }
`;

const HeroCTAs = styled.div`
  text-align: center;
  display: inline-block;
`;

const HeroTier5 = ({
  imgDesktop,
  imgTablet,
  imgMobile,
  imgAlt,
  mediaType,
  h1,
  posthead,
  ctas,
  videoWebm,
  videoMp4,
}) => {
  const processedImgDesktop = Picture.DefaultOrCrop(imgDesktop?.file, imgDesktop?.crop, defaults.heroDesktop);
  const processedImgTablet = Picture.DefaultOrCrop(
    imgTablet?.file,
    imgTablet?.crop,
    imgDesktop?.file || defaults.heroDesktop
  );
  const processedImgMobile = Picture.DefaultOrCrop(
    imgMobile?.file,
    imgMobile?.crop,
    imgDesktop?.file || defaults.heroDesktop
  );
  const imgDesktopAlt = imgDesktop && imgDesktop?.alt ? imgDesktop?.alt : imgAlt;

  return (
    <div>
      <HeroContainer
        imgDesktop={processedImgDesktop}
        imgTablet={processedImgTablet}
        imgMobile={processedImgMobile}
        mediaType={mediaType}
        aria-label={mediaType === 'image' ? imgDesktopAlt : null}
        role={mediaType === 'image' ? 'img' : null}
      >
        {mediaType === 'video' && (
          <HeroVideo playsInline muted autoPlay loop>
            <source src={videoWebm} type="video/webm" />
            <source src={videoMp4} type="video/mp4" />
          </HeroVideo>
        )}

        <MainContent>
          {h1 && <HeroTitle>{h1}</HeroTitle>}
          {posthead && <HeroPosthead>{posthead}</HeroPosthead>}
          {ctas && <HeroCTAs>{ctas}</HeroCTAs>}
        </MainContent>
      </HeroContainer>
    </div>
  );
};

export default HeroTier5;
